// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");
let UnifiedAccountSettingsPageRefetchQuery_graphql = require("./UnifiedAccountSettingsPageRefetchQuery_graphql.bs.js");

let Types = {};

function unwrap_fragment_currentAccountV5_profile(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "IndividualAccountProfile",
    "PreUnifiedAccountProfile",
    "TeamAccountProfile"
  ]);
}

let fragmentConverter = {"__root":{"currentAccountV5_profile":{"u":"fragment_currentAccountV5_profile"}}};

let fragmentConverterMap = {
  fragment_currentAccountV5_profile: unwrap_fragment_currentAccountV5_profile
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

function makeNode(rescript_graphql_node_UnifiedAccountSettingsPageRefetchQuery) {
  return ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": rescript_graphql_node_UnifiedAccountSettingsPageRefetchQuery
    }
  },
  "name": "UnifiedAccountSettingsPage_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountV5",
      "kind": "LinkedField",
      "name": "currentAccountV5",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v1/*: any*/),
                "type": "PreUnifiedAccountProfile",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v1/*: any*/),
                "type": "IndividualAccountProfile",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v1/*: any*/),
                "type": "TeamAccountProfile",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          "action": "THROW"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})());
}

let node = makeNode(UnifiedAccountSettingsPageRefetchQuery_graphql.node);

let wrap_fragment_currentAccountV5_profile = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_currentAccountV5_profile = unwrap_fragment_currentAccountV5_profile;
exports.wrap_fragment_currentAccountV5_profile = wrap_fragment_currentAccountV5_profile;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
